import React, { useRef, useState } from "react";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import CommonDatePickerFilter from "../../../../../../components/filters/CommonDatePicker.filter";
import CommonDropdownFilter from "../../../../../../components/filters/CommonDropdown.filter";
import Checkbox from "../../../../../../components/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
const PriorInvoices = () => {
  const gridRef = useRef();

  const [isChexboxChecked, setIsCheckboxChecked] = useState(false);

  return (
    <>
      <CardSection>
        <div className="prior-invoice-detail">
          <div className="top-form-section">
            <div className="row">
              <div className="col-md-4 from-to-sec">
                <div className="w-100 d-flex gap-3">
                  <CommonDatePickerFilter
                    // value={filter.startDate?.value}
                    label={"From : "}
                    placeholder="MM/DD/YYYY"
                    // onChange={(selectedDate) => handleDatePickerChange("startDate", selectedDate)}
                  />
                  <CommonDatePickerFilter
                    // value={filter.endDate?.value}
                    label={"To : "}
                    placeholder="MM/DD/YYYY"
                    // onChange={(selectedDate) => handleDatePickerChange("endDate", selectedDate)}
                  />
                </div>
              </div>
              <div className="col-md-4 type-spacing">
                <CommonDropdownFilter
                  label={"Contract : "}
                  placeholder="Select Type"
                  // listOptions={filter.type?.options}
                  // selectedValue={filter.type?.value}
                  // onChange={(selectedValue) => handleDropdownChange("type", selectedValue?.value)}
                />
              </div>
              <div className="col-md-2 check-box-sec d-flex align-items-center">
                <Checkbox
                  key="expiredInvoices"
                  name="expiredInvoices"
                  label="Include Expired"
                  checked={isChexboxChecked}
                  onChange={() => setIsCheckboxChecked(!isChexboxChecked)}
                  // checked={instrumentInclude[item.id]}
                  // onChange={(dataField, isChecked) =>
                  //   handleCheckboxChange(dataField, isChecked)
                  // }
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end align-items-center">
                <div className="btn-sec">
                  <Buttons
                    buttonText={"Refresh"}
                    buttonTypeClassName="btn blue-btn"
                    // onClick={() => setIsModelOpen(true)}
                  />
                </div>
              </div>
            </div>
          </div>
          <MolGrid
            ref={gridRef}
            // beforeLoad={beforeMolGridLoad}
            // afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            // ctxMenuItems={getCtxMenuItems}
            // onRowDoubleClick={handleRowDoubleClick}
          >
            <Column
              field="contractKey"
              header="Contract Key"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />
            <Column
              field="contract"
              header="Contract"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "25%" }}
              grouping
              sortable
            />
            <Column
              field="client"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "20%" }}
              grouping
              sortable
            />
            <Column
              field="department"
              header="Department"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "12%" }}
              grouping
              sortable
            />
            <Column
              field="purchaseOrder"
              header="Purchase Order"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="invoiceDate"
              header="Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />
            <Column
              field="invoiceNumber"
              header="Invoice Number"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />

            <Column
              field="invoiceAmount"
              header="Invoice Amount"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />
            <Column
              field="coveragePeriod"
              header="Coverage Period"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
    </>
  );
};

export default PriorInvoices;
